/* Chula — the welcome after a newsletter signup
 *
 * Extracted from snippets/chula-welcome.liquid on 2026-09-20. Inline before,
 * so it shipped on every page and could never be cached. Its one translated
 * string arrives via the #chula-welcome-text JSON island rendered alongside.
 */

(function () {
    if (window.chulaWelcome) return;

    /* The greeting itself, handed over as JSON rather than interpolated:
       this script is a cached .js asset now, and Liquid never runs inside
       one, so the `t` filter has to happen in the Liquid file. */
    var TEXT = (function () {
      var node = document.getElementById('chula-welcome-text');
      try { return node ? JSON.parse(node.textContent) : 'Welcome to Chula'; }
      catch (e) { return 'Welcome to Chula'; }
    })();
    var RTL = document.documentElement.dir === 'rtl';
    var SVGNS = 'http://www.w3.org/2000/svg';
    var running = false;

    function build() {
      var root = document.createElement('div');
      root.className = 'chula-welcome' + (RTL ? ' chula-welcome--rtl' : '');
      root.setAttribute('role', 'status');
      root.setAttribute('aria-live', 'polite');

      var scrim = document.createElement('div');
      scrim.className = 'chula-welcome__scrim';
      root.appendChild(scrim);

      var svg = document.createElementNS(SVGNS, 'svg');
      svg.setAttribute('class', 'chula-welcome__word');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('viewBox', '0 0 600 100');
      var text = document.createElementNS(SVGNS, 'text');
      text.setAttribute('x', '0');
      text.setAttribute('y', '100');
      text.setAttribute('font-size', '100');
      if (RTL) text.setAttribute('direction', 'rtl');
      text.textContent = TEXT;
      svg.appendChild(text);
      root.appendChild(svg);

      var sr = document.createElement('span');
      sr.className = 'sr-only';
      sr.textContent = TEXT;
      root.appendChild(sr);

      return root;
    }

    /* Fit the viewBox to the ink once the face is in. Measured with
       getBBox on the live element, so the aspect ratio is the real one for
       whatever language the string is in. */
    function fit(root) {
      var svg = root.querySelector('svg');
      var box;
      try { box = svg.querySelector('text').getBBox(); } catch (e) { return; }
      if (!box || !box.width) return;
      var pad = box.height * 0.12;
      svg.setAttribute('viewBox', [box.x - pad, box.y - pad, box.width + pad * 2, box.height + pad * 2].join(' '));
      root.style.setProperty('--cw-ratio', ((box.width + pad * 2) / (box.height + pad * 2)).toFixed(3));
    }

    function fontReady() {
      if (!document.fonts || !document.fonts.load) return Promise.resolve();
      /* Jost since 2026-09-24. Vietnamese takes Be Vietnam Pro, matching the
         :root:lang(vi) token swap — Jost has no Vietnamese glyphs, and asking
         for the wrong family here means fit() measures a fallback face and
         writes a viewBox that does not match what renders. Chosen by document
         language rather than loading both, so a non-Vietnamese page does not
         download a face it will never paint. */
      var FAMILY = (document.documentElement.lang || '').toLowerCase().indexOf('vi') === 0
        ? '"Be Vietnam Pro"'
        : '"Jost"';
      var load = document.fonts.load('400 100px ' + FAMILY, TEXT).catch(function () {});
      var timeout = new Promise(function (r) { setTimeout(r, 1500); });
      return Promise.race([load, timeout]);
    }

    window.chulaWelcome = function () {
      if (running) return;
      running = true;

      var root = build();
      root.hidden = true;
      document.body.appendChild(root);

      var outTimer, doneTimer, ended = false;

      function finish() {
        root.remove();
        document.removeEventListener('keydown', skip, true);
        if (window.chulaLockHeader) window.chulaLockHeader(false);
        running = false;
      }

      function leave() {
        if (ended) return;
        ended = true;
        clearTimeout(outTimer);
        root.classList.add('is-out');
        root.classList.remove('is-in');
        doneTimer = setTimeout(finish, 1300);
      }

      function skip() { leave(); }

      fontReady().then(function () {
        root.hidden = false;
        fit(root);
        if (window.chulaLockHeader) window.chulaLockHeader(true);
        void root.offsetHeight;
        root.classList.add('is-in');
        root.addEventListener('click', skip);
        document.addEventListener('keydown', skip, true);
        /* 0.35 delay + 2.8 trace, then a 1.4s hold. */
        outTimer = setTimeout(leave, 4550);
      });
    };
  })();
